var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"d-flex align-items-center justify-content-center",attrs:{"role":"button"}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height,"viewBox":"0 0 22 24","fill":_vm.iconColor,"aria-labelledby":_vm.iconName,"role":"presentation"}},[_c('g',[_c(_vm.icon,{tag:"component"})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }